import { Box, BoxProps, IconButton, Modal } from '@mui/material'

import Close24 from '@evocolabs/icons/lib/Close24'
import SpinningCircle from '@/src/components/SpinningCircle' // Ensure this is the correct path to your spinner component
import { getEnvVar } from '@/env'
import theme from '@/src/theme'
import { useState } from 'react'

interface CalendlyProps extends BoxProps {
  open: boolean
  onClose: () => void
}

const SCHEDULE_PHONE_CALL_URL = getEnvVar('NEXT_PUBLIC_SCHEDULE_PHONE_CALL_URL')

function Calendly({ open, onClose, ...boxProps }: CalendlyProps) {
  const [iframeLoaded, setIframeLoaded] = useState(false)
  const onModalClose = () => {
    setIframeLoaded(false)
    onClose()
  }

  return (
    <Modal open={open} onClose={onModalClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: '100%',
          borderRadius: '8px',
          width: { xs: '100%', dl: '75%' },
          p: { xs: 2, dl: 4 },
          overflow: 'hidden'
        }}
        {...boxProps}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
            borderRadius: '8px',
            margin: 'auto',
            transform: { dl: 'scale(1.0)', xs: 'scale(0.8)' }
          }}
        >
          <IconButton
            onClick={onModalClose}
            sx={{
              position: 'absolute',
              top: 12,
              right: 12,
              zIndex: 999,
              transform: {
                xs: 'translate(30px, -40px)',
                dl: 'translate(20px, -20px)'
              }
            }}
            aria-label="close"
          >
            {iframeLoaded ? (
              <Close24 replaceColor={[['#26201F', theme.palette.grey[800]]]} />
            ) : null}
          </IconButton>
          {!iframeLoaded && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'white'
              }}
            >
              <SpinningCircle />
            </Box>
          )}
          <iframe
            src={SCHEDULE_PHONE_CALL_URL}
            title="Introducing Orka Two Hearing Aids"
            width="100%"
            height="100%"
            style={{ border: 'none', transform: 'scale(1.05)' }}
            onLoad={() => setIframeLoaded(true)}
          />
        </Box>
      </Box>
    </Modal>
  )
}

export default Calendly
